/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const CircleSmallSolidV6 = (props) => (
  <Icon {...props} name="Circle Small Solid V6">
    <path d="M13 8c0 2.763-2.237 5-5 5s-5-2.237-5-5 2.238-5 5-5 5 2.237 5 5z" />
  </Icon>
);

export default CircleSmallSolidV6;
